import { render, staticRenderFns } from "./PageContainer.vue?vue&type=template&id=662d60de&scoped=true"
import script from "./PageContainer.vue?vue&type=script&lang=ts"
export * from "./PageContainer.vue?vue&type=script&lang=ts"
import style0 from "./PageContainer.vue?vue&type=style&index=0&id=662d60de&prod&lang=scss"
import style1 from "./PageContainer.vue?vue&type=style&index=1&id=662d60de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662d60de",
  null
  
)

export default component.exports